// Auto-generated by /app/scripts/enrich_photo_alts.py
// Each photo has an SEO-rich alt + title combining shoot, position, keyword and brand.

export const PHOTO_GALLERY_CATEGORIES = [
  "Hospitality",
  "Food & Beverage",
  "Commercial Product",
  "Lifestyle & Adventure",
  "Editorial & Portraits"
];

export const PHOTO_GALLERY_SHOOTS = [
  {
    "slug": "lanzerac",
    "label": "Lanzerac Wine Estate",
    "category": "Hospitality",
    "protected": false,
    "photos": [
      {
        "id": "Lanzarac_Spa",
        "full": "/portfolio/lanzerac/full/Lanzarac_Spa.webp",
        "thumb": "/portfolio/lanzerac/thumb/Lanzarac_Spa.webp",
        "alt": "Lanzerac Wine Estate - photo 1 of 14 - Lanzerac wine estate photographer Stellenbosch | Pie in the Sky Productions",
        "title": "Lanzerac Wine Estate - Lanzerac wine estate photographer Stellenbosch"
      },
      {
        "id": "Lanzerac",
        "full": "/portfolio/lanzerac/full/Lanzerac.webp",
        "thumb": "/portfolio/lanzerac/thumb/Lanzerac.webp",
        "alt": "Lanzerac Wine Estate - photo 2 of 14 - Lanzerac wine estate photographer Stellenbosch | Pie in the Sky Productions",
        "title": "Lanzerac Wine Estate - Lanzerac wine estate photographer Stellenbosch"
      },
      {
        "id": "Lanzerac_bathroom",
        "full": "/portfolio/lanzerac/full/Lanzerac_bathroom.webp",
        "thumb": "/portfolio/lanzerac/thumb/Lanzerac_bathroom.webp",
        "alt": "Lanzerac Wine Estate - photo 3 of 14 - Lanzerac wine estate photographer Stellenbosch | Pie in the Sky Productions",
        "title": "Lanzerac Wine Estate - Lanzerac wine estate photographer Stellenbosch"
      },
      {
        "id": "Lanzerac_Bathroom_2",
        "full": "/portfolio/lanzerac/full/Lanzerac_Bathroom_2.webp",
        "thumb": "/portfolio/lanzerac/thumb/Lanzerac_Bathroom_2.webp",
        "alt": "Lanzerac Wine Estate - photo 4 of 14 - Lanzerac wine estate photographer Stellenbosch | Pie in the Sky Productions",
        "title": "Lanzerac Wine Estate - Lanzerac wine estate photographer Stellenbosch"
      },
      {
        "id": "Lanzerac_Couple_1",
        "full": "/portfolio/lanzerac/full/Lanzerac_Couple_1.webp",
        "thumb": "/portfolio/lanzerac/thumb/Lanzerac_Couple_1.webp",
        "alt": "Lanzerac Wine Estate - photo 5 of 14 - Lanzerac wine estate photographer Stellenbosch | Pie in the Sky Productions",
        "title": "Lanzerac Wine Estate - Lanzerac wine estate photographer Stellenbosch"
      },
      {
        "id": "Lanzerac_Exterior",
        "full": "/portfolio/lanzerac/full/Lanzerac_Exterior.webp",
        "thumb": "/portfolio/lanzerac/thumb/Lanzerac_Exterior.webp",
        "alt": "Lanzerac Wine Estate - photo 6 of 14 - Lanzerac wine estate photographer Stellenbosch | Pie in the Sky Productions",
        "title": "Lanzerac Wine Estate - Lanzerac wine estate photographer Stellenbosch"
      },
      {
        "id": "Lanzerac_Extreme_Wide",
        "full": "/portfolio/lanzerac/full/Lanzerac_Extreme_Wide.webp",
        "thumb": "/portfolio/lanzerac/thumb/Lanzerac_Extreme_Wide.webp",
        "alt": "Lanzerac Wine Estate - photo 7 of 14 - Lanzerac wine estate photographer Stellenbosch | Pie in the Sky Productions",
        "title": "Lanzerac Wine Estate - Lanzerac wine estate photographer Stellenbosch"
      },
      {
        "id": "Lanzerac_Food_1",
        "full": "/portfolio/lanzerac/full/Lanzerac_Food_1.webp",
        "thumb": "/portfolio/lanzerac/thumb/Lanzerac_Food_1.webp",
        "alt": "Lanzerac Wine Estate - photo 8 of 14 - Lanzerac wine estate photographer Stellenbosch | Pie in the Sky Productions",
        "title": "Lanzerac Wine Estate - Lanzerac wine estate photographer Stellenbosch"
      },
      {
        "id": "Lanzerac_food_3",
        "full": "/portfolio/lanzerac/full/Lanzerac_food_3.webp",
        "thumb": "/portfolio/lanzerac/thumb/Lanzerac_food_3.webp",
        "alt": "Lanzerac Wine Estate - photo 9 of 14 - Lanzerac wine estate photographer Stellenbosch | Pie in the Sky Productions",
        "title": "Lanzerac Wine Estate - Lanzerac wine estate photographer Stellenbosch"
      },
      {
        "id": "Lanzerac_Food_4",
        "full": "/portfolio/lanzerac/full/Lanzerac_Food_4.webp",
        "thumb": "/portfolio/lanzerac/thumb/Lanzerac_Food_4.webp",
        "alt": "Lanzerac Wine Estate - photo 10 of 14 - Lanzerac wine estate photographer Stellenbosch | Pie in the Sky Productions",
        "title": "Lanzerac Wine Estate - Lanzerac wine estate photographer Stellenbosch"
      },
      {
        "id": "Lanzerac_Interior_Room",
        "full": "/portfolio/lanzerac/full/Lanzerac_Interior_Room.webp",
        "thumb": "/portfolio/lanzerac/thumb/Lanzerac_Interior_Room.webp",
        "alt": "Lanzerac Wine Estate - photo 11 of 14 - Lanzerac wine estate photographer Stellenbosch | Pie in the Sky Productions",
        "title": "Lanzerac Wine Estate - Lanzerac wine estate photographer Stellenbosch"
      },
      {
        "id": "Lanzerac_Interior_Room_2",
        "full": "/portfolio/lanzerac/full/Lanzerac_Interior_Room_2.webp",
        "thumb": "/portfolio/lanzerac/thumb/Lanzerac_Interior_Room_2.webp",
        "alt": "Lanzerac Wine Estate - photo 12 of 14 - Lanzerac wine estate photographer Stellenbosch | Pie in the Sky Productions",
        "title": "Lanzerac Wine Estate - Lanzerac wine estate photographer Stellenbosch"
      },
      {
        "id": "Lanzerac_Spa",
        "full": "/portfolio/lanzerac/full/Lanzerac_Spa.webp",
        "thumb": "/portfolio/lanzerac/thumb/Lanzerac_Spa.webp",
        "alt": "Lanzerac Wine Estate - photo 13 of 14 - Lanzerac wine estate photographer Stellenbosch | Pie in the Sky Productions",
        "title": "Lanzerac Wine Estate - Lanzerac wine estate photographer Stellenbosch"
      },
      {
        "id": "Lanzerac_Wine_and_Deli",
        "full": "/portfolio/lanzerac/full/Lanzerac_Wine_and_Deli.webp",
        "thumb": "/portfolio/lanzerac/thumb/Lanzerac_Wine_and_Deli.webp",
        "alt": "Lanzerac Wine Estate - photo 14 of 14 - Lanzerac wine estate photographer Stellenbosch | Pie in the Sky Productions",
        "title": "Lanzerac Wine Estate - Lanzerac wine estate photographer Stellenbosch"
      }
    ],
    "count": 14,
    "seoKeyword": "Lanzerac wine estate photographer Stellenbosch"
  },
  {
    "slug": "crowne-plaza",
    "label": "IHG Crowne Plaza",
    "category": "Hospitality",
    "protected": false,
    "photos": [
      {
        "id": "IHG_Crowne_Plaza-45",
        "full": "/portfolio/crowne-plaza/full/IHG_Crowne_Plaza-45.webp",
        "thumb": "/portfolio/crowne-plaza/thumb/IHG_Crowne_Plaza-45.webp",
        "alt": "IHG Crowne Plaza - photo 1 of 10 - IHG Crowne Plaza hotel photographer Cape Town | Pie in the Sky Productions",
        "title": "IHG Crowne Plaza - IHG Crowne Plaza hotel photographer Cape Town"
      },
      {
        "id": "IHG_Crowne_Plaza-46",
        "full": "/portfolio/crowne-plaza/full/IHG_Crowne_Plaza-46.webp",
        "thumb": "/portfolio/crowne-plaza/thumb/IHG_Crowne_Plaza-46.webp",
        "alt": "IHG Crowne Plaza - photo 2 of 10 - IHG Crowne Plaza hotel photographer Cape Town | Pie in the Sky Productions",
        "title": "IHG Crowne Plaza - IHG Crowne Plaza hotel photographer Cape Town"
      },
      {
        "id": "IHG_Crowne_Plaza-47",
        "full": "/portfolio/crowne-plaza/full/IHG_Crowne_Plaza-47.webp",
        "thumb": "/portfolio/crowne-plaza/thumb/IHG_Crowne_Plaza-47.webp",
        "alt": "IHG Crowne Plaza - photo 3 of 10 - IHG Crowne Plaza hotel photographer Cape Town | Pie in the Sky Productions",
        "title": "IHG Crowne Plaza - IHG Crowne Plaza hotel photographer Cape Town"
      },
      {
        "id": "IHG_Crowne_Plaza-48",
        "full": "/portfolio/crowne-plaza/full/IHG_Crowne_Plaza-48.webp",
        "thumb": "/portfolio/crowne-plaza/thumb/IHG_Crowne_Plaza-48.webp",
        "alt": "IHG Crowne Plaza - photo 4 of 10 - IHG Crowne Plaza hotel photographer Cape Town | Pie in the Sky Productions",
        "title": "IHG Crowne Plaza - IHG Crowne Plaza hotel photographer Cape Town"
      },
      {
        "id": "IHG_Crowne_Plaza-49",
        "full": "/portfolio/crowne-plaza/full/IHG_Crowne_Plaza-49.webp",
        "thumb": "/portfolio/crowne-plaza/thumb/IHG_Crowne_Plaza-49.webp",
        "alt": "IHG Crowne Plaza - photo 5 of 10 - IHG Crowne Plaza hotel photographer Cape Town | Pie in the Sky Productions",
        "title": "IHG Crowne Plaza - IHG Crowne Plaza hotel photographer Cape Town"
      },
      {
        "id": "IHG_Crowne_Plaza-50",
        "full": "/portfolio/crowne-plaza/full/IHG_Crowne_Plaza-50.webp",
        "thumb": "/portfolio/crowne-plaza/thumb/IHG_Crowne_Plaza-50.webp",
        "alt": "IHG Crowne Plaza - photo 6 of 10 - IHG Crowne Plaza hotel photographer Cape Town | Pie in the Sky Productions",
        "title": "IHG Crowne Plaza - IHG Crowne Plaza hotel photographer Cape Town"
      },
      {
        "id": "IHG_Crowne_Plaza-51",
        "full": "/portfolio/crowne-plaza/full/IHG_Crowne_Plaza-51.webp",
        "thumb": "/portfolio/crowne-plaza/thumb/IHG_Crowne_Plaza-51.webp",
        "alt": "IHG Crowne Plaza - photo 7 of 10 - IHG Crowne Plaza hotel photographer Cape Town | Pie in the Sky Productions",
        "title": "IHG Crowne Plaza - IHG Crowne Plaza hotel photographer Cape Town"
      },
      {
        "id": "IHG_Crowne_Plaza-52",
        "full": "/portfolio/crowne-plaza/full/IHG_Crowne_Plaza-52.webp",
        "thumb": "/portfolio/crowne-plaza/thumb/IHG_Crowne_Plaza-52.webp",
        "alt": "IHG Crowne Plaza - photo 8 of 10 - IHG Crowne Plaza hotel photographer Cape Town | Pie in the Sky Productions",
        "title": "IHG Crowne Plaza - IHG Crowne Plaza hotel photographer Cape Town"
      },
      {
        "id": "IHG_Crowne_Plaza-53",
        "full": "/portfolio/crowne-plaza/full/IHG_Crowne_Plaza-53.webp",
        "thumb": "/portfolio/crowne-plaza/thumb/IHG_Crowne_Plaza-53.webp",
        "alt": "IHG Crowne Plaza - photo 9 of 10 - IHG Crowne Plaza hotel photographer Cape Town | Pie in the Sky Productions",
        "title": "IHG Crowne Plaza - IHG Crowne Plaza hotel photographer Cape Town"
      },
      {
        "id": "IHG_Crowne_Plaza-54",
        "full": "/portfolio/crowne-plaza/full/IHG_Crowne_Plaza-54.webp",
        "thumb": "/portfolio/crowne-plaza/thumb/IHG_Crowne_Plaza-54.webp",
        "alt": "IHG Crowne Plaza - photo 10 of 10 - IHG Crowne Plaza hotel photographer Cape Town | Pie in the Sky Productions",
        "title": "IHG Crowne Plaza - IHG Crowne Plaza hotel photographer Cape Town"
      }
    ],
    "count": 10,
    "seoKeyword": "IHG Crowne Plaza hotel photographer Cape Town"
  },
  {
    "slug": "crystal-serenity",
    "label": "Crystal Serenity Luxury Cruise",
    "category": "Hospitality",
    "protected": false,
    "photos": [
      {
        "id": "Crystal_Serenity_1",
        "full": "/portfolio/crystal-serenity/full/Crystal_Serenity_1.webp",
        "thumb": "/portfolio/crystal-serenity/thumb/Crystal_Serenity_1.webp",
        "alt": "Crystal Serenity Luxury Cruise - photo 1 of 6 - Crystal Serenity luxury cruise photographer | Pie in the Sky Productions",
        "title": "Crystal Serenity Luxury Cruise - Crystal Serenity luxury cruise photographer"
      },
      {
        "id": "Crystal_Serenity_5",
        "full": "/portfolio/crystal-serenity/full/Crystal_Serenity_5.webp",
        "thumb": "/portfolio/crystal-serenity/thumb/Crystal_Serenity_5.webp",
        "alt": "Crystal Serenity Luxury Cruise - photo 2 of 6 - Crystal Serenity luxury cruise photographer | Pie in the Sky Productions",
        "title": "Crystal Serenity Luxury Cruise - Crystal Serenity luxury cruise photographer"
      },
      {
        "id": "Crystal_Serenity_6",
        "full": "/portfolio/crystal-serenity/full/Crystal_Serenity_6.webp",
        "thumb": "/portfolio/crystal-serenity/thumb/Crystal_Serenity_6.webp",
        "alt": "Crystal Serenity Luxury Cruise - photo 3 of 6 - Crystal Serenity luxury cruise photographer | Pie in the Sky Productions",
        "title": "Crystal Serenity Luxury Cruise - Crystal Serenity luxury cruise photographer"
      },
      {
        "id": "Cyrstal_Serenity_2",
        "full": "/portfolio/crystal-serenity/full/Cyrstal_Serenity_2.webp",
        "thumb": "/portfolio/crystal-serenity/thumb/Cyrstal_Serenity_2.webp",
        "alt": "Crystal Serenity Luxury Cruise - photo 4 of 6 - Crystal Serenity luxury cruise photographer | Pie in the Sky Productions",
        "title": "Crystal Serenity Luxury Cruise - Crystal Serenity luxury cruise photographer"
      },
      {
        "id": "Cyrstal_Serenity_3",
        "full": "/portfolio/crystal-serenity/full/Cyrstal_Serenity_3.webp",
        "thumb": "/portfolio/crystal-serenity/thumb/Cyrstal_Serenity_3.webp",
        "alt": "Crystal Serenity Luxury Cruise - photo 5 of 6 - Crystal Serenity luxury cruise photographer | Pie in the Sky Productions",
        "title": "Crystal Serenity Luxury Cruise - Crystal Serenity luxury cruise photographer"
      },
      {
        "id": "Cyrstal_Serenity_4",
        "full": "/portfolio/crystal-serenity/full/Cyrstal_Serenity_4.webp",
        "thumb": "/portfolio/crystal-serenity/thumb/Cyrstal_Serenity_4.webp",
        "alt": "Crystal Serenity Luxury Cruise - photo 6 of 6 - Crystal Serenity luxury cruise photographer | Pie in the Sky Productions",
        "title": "Crystal Serenity Luxury Cruise - Crystal Serenity luxury cruise photographer"
      }
    ],
    "count": 6,
    "seoKeyword": "Crystal Serenity luxury cruise photographer"
  },
  {
    "slug": "interiors-lifestyle",
    "label": "Interiors & Lifestyle",
    "category": "Hospitality",
    "protected": false,
    "photos": [
      {
        "id": "Chandelier",
        "full": "/portfolio/interiors-lifestyle/full/Chandelier.webp",
        "thumb": "/portfolio/interiors-lifestyle/thumb/Chandelier.webp",
        "alt": "Interiors & Lifestyle - photo 1 of 5 - luxury hotel interior photographer Cape Town | Pie in the Sky Productions",
        "title": "Interiors & Lifestyle - luxury hotel interior photographer Cape Town"
      },
      {
        "id": "Coastal_Resturant_Exterior",
        "full": "/portfolio/interiors-lifestyle/full/Coastal_Resturant_Exterior.webp",
        "thumb": "/portfolio/interiors-lifestyle/thumb/Coastal_Resturant_Exterior.webp",
        "alt": "Interiors & Lifestyle - photo 2 of 5 - luxury hotel interior photographer Cape Town | Pie in the Sky Productions",
        "title": "Interiors & Lifestyle - luxury hotel interior photographer Cape Town"
      },
      {
        "id": "Couple_on_Boat",
        "full": "/portfolio/interiors-lifestyle/full/Couple_on_Boat.webp",
        "thumb": "/portfolio/interiors-lifestyle/thumb/Couple_on_Boat.webp",
        "alt": "Interiors & Lifestyle - photo 3 of 5 - luxury hotel interior photographer Cape Town | Pie in the Sky Productions",
        "title": "Interiors & Lifestyle - luxury hotel interior photographer Cape Town"
      },
      {
        "id": "Fire_Place",
        "full": "/portfolio/interiors-lifestyle/full/Fire_Place.webp",
        "thumb": "/portfolio/interiors-lifestyle/thumb/Fire_Place.webp",
        "alt": "Interiors & Lifestyle - photo 4 of 5 - luxury hotel interior photographer Cape Town | Pie in the Sky Productions",
        "title": "Interiors & Lifestyle - luxury hotel interior photographer Cape Town"
      },
      {
        "id": "Interior_Hotel",
        "full": "/portfolio/interiors-lifestyle/full/Interior_Hotel.webp",
        "thumb": "/portfolio/interiors-lifestyle/thumb/Interior_Hotel.webp",
        "alt": "Interiors & Lifestyle - photo 5 of 5 - luxury hotel interior photographer Cape Town | Pie in the Sky Productions",
        "title": "Interiors & Lifestyle - luxury hotel interior photographer Cape Town"
      }
    ],
    "count": 5,
    "seoKeyword": "luxury hotel interior photographer Cape Town"
  },
  {
    "slug": "taj-cape-town",
    "label": "Taj Cape Town",
    "category": "Hospitality",
    "protected": false,
    "photos": [
      {
        "id": "Taj_Hotel_Enterance",
        "full": "/portfolio/taj-cape-town/full/Taj_Hotel_Enterance.webp",
        "thumb": "/portfolio/taj-cape-town/thumb/Taj_Hotel_Enterance.webp",
        "alt": "Taj Cape Town - photo 1 of 5 - Taj Cape Town hotel photographer | Pie in the Sky Productions",
        "title": "Taj Cape Town - Taj Cape Town hotel photographer"
      },
      {
        "id": "Taj_Hotel_Room_1_1",
        "full": "/portfolio/taj-cape-town/full/Taj_Hotel_Room_1_1.webp",
        "thumb": "/portfolio/taj-cape-town/thumb/Taj_Hotel_Room_1_1.webp",
        "alt": "Taj Cape Town - photo 2 of 5 - Taj Cape Town hotel photographer | Pie in the Sky Productions",
        "title": "Taj Cape Town - Taj Cape Town hotel photographer"
      },
      {
        "id": "Taj_Hotel_Room_1_2",
        "full": "/portfolio/taj-cape-town/full/Taj_Hotel_Room_1_2.webp",
        "thumb": "/portfolio/taj-cape-town/thumb/Taj_Hotel_Room_1_2.webp",
        "alt": "Taj Cape Town - photo 3 of 5 - Taj Cape Town hotel photographer | Pie in the Sky Productions",
        "title": "Taj Cape Town - Taj Cape Town hotel photographer"
      },
      {
        "id": "Taj_Hotel_Room_2",
        "full": "/portfolio/taj-cape-town/full/Taj_Hotel_Room_2.webp",
        "thumb": "/portfolio/taj-cape-town/thumb/Taj_Hotel_Room_2.webp",
        "alt": "Taj Cape Town - photo 4 of 5 - Taj Cape Town hotel photographer | Pie in the Sky Productions",
        "title": "Taj Cape Town - Taj Cape Town hotel photographer"
      },
      {
        "id": "Taj_Hotel_White_Dress",
        "full": "/portfolio/taj-cape-town/full/Taj_Hotel_White_Dress.webp",
        "thumb": "/portfolio/taj-cape-town/thumb/Taj_Hotel_White_Dress.webp",
        "alt": "Taj Cape Town - photo 5 of 5 - Taj Cape Town hotel photographer | Pie in the Sky Productions",
        "title": "Taj Cape Town - Taj Cape Town hotel photographer"
      }
    ],
    "count": 5,
    "seoKeyword": "Taj Cape Town hotel photographer"
  },
  {
    "slug": "mauritius",
    "label": "Mauritius Resort Portfolio",
    "category": "Hospitality",
    "protected": false,
    "photos": [
      {
        "id": "Mauritius_Building_Exterior",
        "full": "/portfolio/mauritius/full/Mauritius_Building_Exterior.webp",
        "thumb": "/portfolio/mauritius/thumb/Mauritius_Building_Exterior.webp",
        "alt": "Mauritius Resort Portfolio - photo 1 of 4 - Mauritius luxury resort photographer | Pie in the Sky Productions",
        "title": "Mauritius Resort Portfolio - Mauritius luxury resort photographer"
      },
      {
        "id": "Maurituis_Buling_Exterior_2",
        "full": "/portfolio/mauritius/full/Maurituis_Buling_Exterior_2.webp",
        "thumb": "/portfolio/mauritius/thumb/Maurituis_Buling_Exterior_2.webp",
        "alt": "Mauritius Resort Portfolio - photo 2 of 4 - Mauritius luxury resort photographer | Pie in the Sky Productions",
        "title": "Mauritius Resort Portfolio - Mauritius luxury resort photographer"
      },
      {
        "id": "Maurituis_Outdoors_exterior",
        "full": "/portfolio/mauritius/full/Maurituis_Outdoors_exterior.webp",
        "thumb": "/portfolio/mauritius/thumb/Maurituis_Outdoors_exterior.webp",
        "alt": "Mauritius Resort Portfolio - photo 3 of 4 - Mauritius luxury resort photographer | Pie in the Sky Productions",
        "title": "Mauritius Resort Portfolio - Mauritius luxury resort photographer"
      },
      {
        "id": "Maurituis_Outside_Drone",
        "full": "/portfolio/mauritius/full/Maurituis_Outside_Drone.webp",
        "thumb": "/portfolio/mauritius/thumb/Maurituis_Outside_Drone.webp",
        "alt": "Mauritius Resort Portfolio - photo 4 of 4 - Mauritius luxury resort photographer | Pie in the Sky Productions",
        "title": "Mauritius Resort Portfolio - Mauritius luxury resort photographer"
      }
    ],
    "count": 4,
    "seoKeyword": "Mauritius luxury resort photographer"
  },
  {
    "slug": "mount-nelson",
    "label": "Mount Nelson Hotel",
    "category": "Hospitality",
    "protected": false,
    "photos": [
      {
        "id": "Mount_Nelson_Hotel",
        "full": "/portfolio/mount-nelson/full/Mount_Nelson_Hotel.webp",
        "thumb": "/portfolio/mount-nelson/thumb/Mount_Nelson_Hotel.webp",
        "alt": "Mount Nelson Hotel - photo 1 of 1 - Mount Nelson hotel photographer Cape Town | Pie in the Sky Productions",
        "title": "Mount Nelson Hotel - Mount Nelson hotel photographer Cape Town"
      }
    ],
    "count": 1,
    "seoKeyword": "Mount Nelson hotel photographer Cape Town"
  },
  {
    "slug": "twelve-apostles",
    "label": "The Twelve Apostles Hotel & Spa",
    "category": "Hospitality",
    "protected": false,
    "photos": [
      {
        "id": "Twelve_Apolstles_Exterior",
        "full": "/portfolio/twelve-apostles/full/Twelve_Apolstles_Exterior.webp",
        "thumb": "/portfolio/twelve-apostles/thumb/Twelve_Apolstles_Exterior.webp",
        "alt": "The Twelve Apostles Hotel & Spa - photo 1 of 1 - Twelve Apostles Hotel & Spa photographer Cape Town | Pie in the Sky Productions",
        "title": "The Twelve Apostles Hotel & Spa - Twelve Apostles Hotel & Spa photographer Cape Town"
      }
    ],
    "count": 1,
    "seoKeyword": "Twelve Apostles Hotel & Spa photographer Cape Town"
  },
  {
    "slug": "fine-dining",
    "label": "Fine Dining & Culinary",
    "category": "Food & Beverage",
    "protected": false,
    "photos": [
      {
        "id": "Pan_dish_top_down",
        "full": "/portfolio/fine-dining/full/Pan_dish_top_down.webp",
        "thumb": "/portfolio/fine-dining/thumb/Pan_dish_top_down.webp",
        "alt": "Fine Dining & Culinary - photo 1 of 5 - fine dining food photographer Cape Town | Pie in the Sky Productions",
        "title": "Fine Dining & Culinary - fine dining food photographer Cape Town"
      },
      {
        "id": "Sea_food_showcase",
        "full": "/portfolio/fine-dining/full/Sea_food_showcase.webp",
        "thumb": "/portfolio/fine-dining/thumb/Sea_food_showcase.webp",
        "alt": "Fine Dining & Culinary - photo 2 of 5 - fine dining food photographer Cape Town | Pie in the Sky Productions",
        "title": "Fine Dining & Culinary - fine dining food photographer Cape Town"
      },
      {
        "id": "Sea_food_showcase_2",
        "full": "/portfolio/fine-dining/full/Sea_food_showcase_2.webp",
        "thumb": "/portfolio/fine-dining/thumb/Sea_food_showcase_2.webp",
        "alt": "Fine Dining & Culinary - photo 3 of 5 - fine dining food photographer Cape Town | Pie in the Sky Productions",
        "title": "Fine Dining & Culinary - fine dining food photographer Cape Town"
      },
      {
        "id": "Sushi_Side_view",
        "full": "/portfolio/fine-dining/full/Sushi_Side_view.webp",
        "thumb": "/portfolio/fine-dining/thumb/Sushi_Side_view.webp",
        "alt": "Fine Dining & Culinary - photo 4 of 5 - fine dining food photographer Cape Town | Pie in the Sky Productions",
        "title": "Fine Dining & Culinary - fine dining food photographer Cape Town"
      },
      {
        "id": "Sushi_Top_Down",
        "full": "/portfolio/fine-dining/full/Sushi_Top_Down.webp",
        "thumb": "/portfolio/fine-dining/thumb/Sushi_Top_Down.webp",
        "alt": "Fine Dining & Culinary - photo 5 of 5 - fine dining food photographer Cape Town | Pie in the Sky Productions",
        "title": "Fine Dining & Culinary - fine dining food photographer Cape Town"
      }
    ],
    "count": 5,
    "seoKeyword": "fine dining food photographer Cape Town"
  },
  {
    "slug": "luxury-dining",
    "label": "Luxury Dining Editorial",
    "category": "Food & Beverage",
    "protected": false,
    "photos": [
      {
        "id": "Luxury_Blue_Drink",
        "full": "/portfolio/luxury-dining/full/Luxury_Blue_Drink.webp",
        "thumb": "/portfolio/luxury-dining/thumb/Luxury_Blue_Drink.webp",
        "alt": "Luxury Dining Editorial - photo 1 of 4 - luxury dining editorial photographer Cape Town | Pie in the Sky Productions",
        "title": "Luxury Dining Editorial - luxury dining editorial photographer Cape Town"
      },
      {
        "id": "Luxury_Dinning_Afternoon",
        "full": "/portfolio/luxury-dining/full/Luxury_Dinning_Afternoon.webp",
        "thumb": "/portfolio/luxury-dining/thumb/Luxury_Dinning_Afternoon.webp",
        "alt": "Luxury Dining Editorial - photo 2 of 4 - luxury dining editorial photographer Cape Town | Pie in the Sky Productions",
        "title": "Luxury Dining Editorial - luxury dining editorial photographer Cape Town"
      },
      {
        "id": "Luxury_Dinning_Afternoon_2",
        "full": "/portfolio/luxury-dining/full/Luxury_Dinning_Afternoon_2.webp",
        "thumb": "/portfolio/luxury-dining/thumb/Luxury_Dinning_Afternoon_2.webp",
        "alt": "Luxury Dining Editorial - photo 3 of 4 - luxury dining editorial photographer Cape Town | Pie in the Sky Productions",
        "title": "Luxury Dining Editorial - luxury dining editorial photographer Cape Town"
      },
      {
        "id": "Luxury_Drink_2",
        "full": "/portfolio/luxury-dining/full/Luxury_Drink_2.webp",
        "thumb": "/portfolio/luxury-dining/thumb/Luxury_Drink_2.webp",
        "alt": "Luxury Dining Editorial - photo 4 of 4 - luxury dining editorial photographer Cape Town | Pie in the Sky Productions",
        "title": "Luxury Dining Editorial - luxury dining editorial photographer Cape Town"
      }
    ],
    "count": 4,
    "seoKeyword": "luxury dining editorial photographer Cape Town"
  },
  {
    "slug": "hasu",
    "label": "Hasu Restaurant",
    "category": "Food & Beverage",
    "protected": false,
    "photos": [
      {
        "id": "Hasu_Exterior",
        "full": "/portfolio/hasu/full/Hasu_Exterior.webp",
        "thumb": "/portfolio/hasu/thumb/Hasu_Exterior.webp",
        "alt": "Hasu Restaurant - photo 1 of 1 - Hasu restaurant food photographer Cape Town | Pie in the Sky Productions",
        "title": "Hasu Restaurant - Hasu restaurant food photographer Cape Town"
      }
    ],
    "count": 1,
    "seoKeyword": "Hasu restaurant food photographer Cape Town"
  },
  {
    "slug": "wine-product",
    "label": "Wine Product Photography",
    "category": "Food & Beverage",
    "protected": false,
    "photos": [
      {
        "id": "pinot_noir_pink",
        "full": "/portfolio/wine-product/full/pinot_noir_pink.webp",
        "thumb": "/portfolio/wine-product/thumb/pinot_noir_pink.webp",
        "alt": "Wine Product Photography - photo 1 of 1 - wine product photographer South Africa | Pie in the Sky Productions",
        "title": "Wine Product Photography - wine product photographer South Africa"
      }
    ],
    "count": 1,
    "seoKeyword": "wine product photographer South Africa"
  },
  {
    "slug": "pharma-product",
    "label": "Pharmaceutical Product Photography",
    "category": "Commercial Product",
    "protected": false,
    "photos": [
      {
        "id": "1_bottle_1_vile_and_a_square_box",
        "full": "/portfolio/pharma-product/full/1_bottle_1_vile_and_a_square_box.webp",
        "thumb": "/portfolio/pharma-product/thumb/1_bottle_1_vile_and_a_square_box.webp",
        "alt": "Pharmaceutical Product Photography - photo 1 of 13 - pharmaceutical product photographer South Africa | Pie in the Sky Productions",
        "title": "Pharmaceutical Product Photography - pharmaceutical product photographer South Africa"
      },
      {
        "id": "2_bottles_1_vile_and_a_Square_box",
        "full": "/portfolio/pharma-product/full/2_bottles_1_vile_and_a_Square_box.webp",
        "thumb": "/portfolio/pharma-product/thumb/2_bottles_1_vile_and_a_Square_box.webp",
        "alt": "Pharmaceutical Product Photography - photo 2 of 13 - pharmaceutical product photographer South Africa | Pie in the Sky Productions",
        "title": "Pharmaceutical Product Photography - pharmaceutical product photographer South Africa"
      },
      {
        "id": "2_bottles_and_a_Rectangle_box",
        "full": "/portfolio/pharma-product/full/2_bottles_and_a_Rectangle_box.webp",
        "thumb": "/portfolio/pharma-product/thumb/2_bottles_and_a_Rectangle_box.webp",
        "alt": "Pharmaceutical Product Photography - photo 3 of 13 - pharmaceutical product photographer South Africa | Pie in the Sky Productions",
        "title": "Pharmaceutical Product Photography - pharmaceutical product photographer South Africa"
      },
      {
        "id": "2_boxes",
        "full": "/portfolio/pharma-product/full/2_boxes.webp",
        "thumb": "/portfolio/pharma-product/thumb/2_boxes.webp",
        "alt": "Pharmaceutical Product Photography - photo 4 of 13 - pharmaceutical product photographer South Africa | Pie in the Sky Productions",
        "title": "Pharmaceutical Product Photography - pharmaceutical product photographer South Africa"
      },
      {
        "id": "2_Trays",
        "full": "/portfolio/pharma-product/full/2_Trays.webp",
        "thumb": "/portfolio/pharma-product/thumb/2_Trays.webp",
        "alt": "Pharmaceutical Product Photography - photo 5 of 13 - pharmaceutical product photographer South Africa | Pie in the Sky Productions",
        "title": "Pharmaceutical Product Photography - pharmaceutical product photographer South Africa"
      },
      {
        "id": "2_Trays_4_Viles_and_4_boxes_no_bar_codes",
        "full": "/portfolio/pharma-product/full/2_Trays_4_Viles_and_4_boxes_no_bar_codes.webp",
        "thumb": "/portfolio/pharma-product/thumb/2_Trays_4_Viles_and_4_boxes_no_bar_codes.webp",
        "alt": "Pharmaceutical Product Photography - photo 6 of 13 - pharmaceutical product photographer South Africa | Pie in the Sky Productions",
        "title": "Pharmaceutical Product Photography - pharmaceutical product photographer South Africa"
      },
      {
        "id": "2_Viles",
        "full": "/portfolio/pharma-product/full/2_Viles.webp",
        "thumb": "/portfolio/pharma-product/thumb/2_Viles.webp",
        "alt": "Pharmaceutical Product Photography - photo 7 of 13 - pharmaceutical product photographer South Africa | Pie in the Sky Productions",
        "title": "Pharmaceutical Product Photography - pharmaceutical product photographer South Africa"
      },
      {
        "id": "3_bottles_and_a_Square_box",
        "full": "/portfolio/pharma-product/full/3_bottles_and_a_Square_box.webp",
        "thumb": "/portfolio/pharma-product/thumb/3_bottles_and_a_Square_box.webp",
        "alt": "Pharmaceutical Product Photography - photo 8 of 13 - pharmaceutical product photographer South Africa | Pie in the Sky Productions",
        "title": "Pharmaceutical Product Photography - pharmaceutical product photographer South Africa"
      },
      {
        "id": "3_boxes",
        "full": "/portfolio/pharma-product/full/3_boxes.webp",
        "thumb": "/portfolio/pharma-product/thumb/3_boxes.webp",
        "alt": "Pharmaceutical Product Photography - photo 9 of 13 - pharmaceutical product photographer South Africa | Pie in the Sky Productions",
        "title": "Pharmaceutical Product Photography - pharmaceutical product photographer South Africa"
      },
      {
        "id": "3_Trays",
        "full": "/portfolio/pharma-product/full/3_Trays.webp",
        "thumb": "/portfolio/pharma-product/thumb/3_Trays.webp",
        "alt": "Pharmaceutical Product Photography - photo 10 of 13 - pharmaceutical product photographer South Africa | Pie in the Sky Productions",
        "title": "Pharmaceutical Product Photography - pharmaceutical product photographer South Africa"
      },
      {
        "id": "3_viles_and_a_Square_box",
        "full": "/portfolio/pharma-product/full/3_viles_and_a_Square_box.webp",
        "thumb": "/portfolio/pharma-product/thumb/3_viles_and_a_Square_box.webp",
        "alt": "Pharmaceutical Product Photography - photo 11 of 13 - pharmaceutical product photographer South Africa | Pie in the Sky Productions",
        "title": "Pharmaceutical Product Photography - pharmaceutical product photographer South Africa"
      },
      {
        "id": "All_products_with_no_bar_codes",
        "full": "/portfolio/pharma-product/full/All_products_with_no_bar_codes.webp",
        "thumb": "/portfolio/pharma-product/thumb/All_products_with_no_bar_codes.webp",
        "alt": "Pharmaceutical Product Photography - photo 12 of 13 - pharmaceutical product photographer South Africa | Pie in the Sky Productions",
        "title": "Pharmaceutical Product Photography - pharmaceutical product photographer South Africa"
      },
      {
        "id": "Untitled-2_copy",
        "full": "/portfolio/pharma-product/full/Untitled-2_copy.webp",
        "thumb": "/portfolio/pharma-product/thumb/Untitled-2_copy.webp",
        "alt": "Pharmaceutical Product Photography - photo 13 of 13 - pharmaceutical product photographer South Africa | Pie in the Sky Productions",
        "title": "Pharmaceutical Product Photography - pharmaceutical product photographer South Africa"
      }
    ],
    "count": 13,
    "seoKeyword": "pharmaceutical product photographer South Africa"
  },
  {
    "slug": "cloud-bubble",
    "label": "Cloud Bubble - Commercial",
    "category": "Commercial Product",
    "protected": false,
    "photos": [
      {
        "id": "After_Cloud_Bubble_Pops",
        "full": "/portfolio/cloud-bubble/full/After_Cloud_Bubble_Pops.webp",
        "thumb": "/portfolio/cloud-bubble/thumb/After_Cloud_Bubble_Pops.webp",
        "alt": "Cloud Bubble - Commercial - photo 1 of 2 - commercial product photographer Cape Town | Pie in the Sky Productions",
        "title": "Cloud Bubble - Commercial - commercial product photographer Cape Town"
      },
      {
        "id": "Before_Cloud_Bubble_Pops",
        "full": "/portfolio/cloud-bubble/full/Before_Cloud_Bubble_Pops.webp",
        "thumb": "/portfolio/cloud-bubble/thumb/Before_Cloud_Bubble_Pops.webp",
        "alt": "Cloud Bubble - Commercial - photo 2 of 2 - commercial product photographer Cape Town | Pie in the Sky Productions",
        "title": "Cloud Bubble - Commercial - commercial product photographer Cape Town"
      }
    ],
    "count": 2,
    "seoKeyword": "commercial product photographer Cape Town"
  },
  {
    "slug": "kayak-lifestyle",
    "label": "Kayak Lifestyle Shoot",
    "category": "Lifestyle & Adventure",
    "protected": false,
    "photos": [
      {
        "id": "Kayak",
        "full": "/portfolio/kayak-lifestyle/full/Kayak.webp",
        "thumb": "/portfolio/kayak-lifestyle/thumb/Kayak.webp",
        "alt": "Kayak Lifestyle Shoot - photo 1 of 9 - outdoor & adventure photographer Cape Town | Pie in the Sky Productions",
        "title": "Kayak Lifestyle Shoot - outdoor & adventure photographer Cape Town"
      },
      {
        "id": "Kayak_Bright_day_Extreme_Wide",
        "full": "/portfolio/kayak-lifestyle/full/Kayak_Bright_day_Extreme_Wide.webp",
        "thumb": "/portfolio/kayak-lifestyle/thumb/Kayak_Bright_day_Extreme_Wide.webp",
        "alt": "Kayak Lifestyle Shoot - photo 2 of 9 - outdoor & adventure photographer Cape Town | Pie in the Sky Productions",
        "title": "Kayak Lifestyle Shoot - outdoor & adventure photographer Cape Town"
      },
      {
        "id": "Kayak_bright_Day_Extreme_Wide_2",
        "full": "/portfolio/kayak-lifestyle/full/Kayak_bright_Day_Extreme_Wide_2.webp",
        "thumb": "/portfolio/kayak-lifestyle/thumb/Kayak_bright_Day_Extreme_Wide_2.webp",
        "alt": "Kayak Lifestyle Shoot - photo 3 of 9 - outdoor & adventure photographer Cape Town | Pie in the Sky Productions",
        "title": "Kayak Lifestyle Shoot - outdoor & adventure photographer Cape Town"
      },
      {
        "id": "Kayak_Landscape_Wide_Shot",
        "full": "/portfolio/kayak-lifestyle/full/Kayak_Landscape_Wide_Shot.webp",
        "thumb": "/portfolio/kayak-lifestyle/thumb/Kayak_Landscape_Wide_Shot.webp",
        "alt": "Kayak Lifestyle Shoot - photo 4 of 9 - outdoor & adventure photographer Cape Town | Pie in the Sky Productions",
        "title": "Kayak Lifestyle Shoot - outdoor & adventure photographer Cape Town"
      },
      {
        "id": "Kayak_Orange_Light",
        "full": "/portfolio/kayak-lifestyle/full/Kayak_Orange_Light.webp",
        "thumb": "/portfolio/kayak-lifestyle/thumb/Kayak_Orange_Light.webp",
        "alt": "Kayak Lifestyle Shoot - photo 5 of 9 - outdoor & adventure photographer Cape Town | Pie in the Sky Productions",
        "title": "Kayak Lifestyle Shoot - outdoor & adventure photographer Cape Town"
      },
      {
        "id": "Kayak_Orange_Light_2",
        "full": "/portfolio/kayak-lifestyle/full/Kayak_Orange_Light_2.webp",
        "thumb": "/portfolio/kayak-lifestyle/thumb/Kayak_Orange_Light_2.webp",
        "alt": "Kayak Lifestyle Shoot - photo 6 of 9 - outdoor & adventure photographer Cape Town | Pie in the Sky Productions",
        "title": "Kayak Lifestyle Shoot - outdoor & adventure photographer Cape Town"
      },
      {
        "id": "Kayak_Orange_Light_3",
        "full": "/portfolio/kayak-lifestyle/full/Kayak_Orange_Light_3.webp",
        "thumb": "/portfolio/kayak-lifestyle/thumb/Kayak_Orange_Light_3.webp",
        "alt": "Kayak Lifestyle Shoot - photo 7 of 9 - outdoor & adventure photographer Cape Town | Pie in the Sky Productions",
        "title": "Kayak Lifestyle Shoot - outdoor & adventure photographer Cape Town"
      },
      {
        "id": "Kayak_Top_Down_Clear_Water",
        "full": "/portfolio/kayak-lifestyle/full/Kayak_Top_Down_Clear_Water.webp",
        "thumb": "/portfolio/kayak-lifestyle/thumb/Kayak_Top_Down_Clear_Water.webp",
        "alt": "Kayak Lifestyle Shoot - photo 8 of 9 - outdoor & adventure photographer Cape Town | Pie in the Sky Productions",
        "title": "Kayak Lifestyle Shoot - outdoor & adventure photographer Cape Town"
      },
      {
        "id": "Kayak_Top_Down_Clear_Water_2",
        "full": "/portfolio/kayak-lifestyle/full/Kayak_Top_Down_Clear_Water_2.webp",
        "thumb": "/portfolio/kayak-lifestyle/thumb/Kayak_Top_Down_Clear_Water_2.webp",
        "alt": "Kayak Lifestyle Shoot - photo 9 of 9 - outdoor & adventure photographer Cape Town | Pie in the Sky Productions",
        "title": "Kayak Lifestyle Shoot - outdoor & adventure photographer Cape Town"
      }
    ],
    "count": 9,
    "seoKeyword": "outdoor & adventure photographer Cape Town"
  },
  {
    "slug": "wellness-yoga",
    "label": "Wellness & Yoga",
    "category": "Lifestyle & Adventure",
    "protected": false,
    "photos": [
      {
        "id": "Yoga_1",
        "full": "/portfolio/wellness-yoga/full/Yoga_1.webp",
        "thumb": "/portfolio/wellness-yoga/thumb/Yoga_1.webp",
        "alt": "Wellness & Yoga - photo 1 of 2 - wellness & spa photographer Cape Town | Pie in the Sky Productions",
        "title": "Wellness & Yoga - wellness & spa photographer Cape Town"
      },
      {
        "id": "Yoga_2",
        "full": "/portfolio/wellness-yoga/full/Yoga_2.webp",
        "thumb": "/portfolio/wellness-yoga/thumb/Yoga_2.webp",
        "alt": "Wellness & Yoga - photo 2 of 2 - wellness & spa photographer Cape Town | Pie in the Sky Productions",
        "title": "Wellness & Yoga - wellness & spa photographer Cape Town"
      }
    ],
    "count": 2,
    "seoKeyword": "wellness & spa photographer Cape Town"
  },
  {
    "slug": "editorial-misc",
    "label": "Editorial - Selected Frames",
    "category": "Editorial & Portraits",
    "protected": false,
    "photos": [
      {
        "id": "IMG_0129-Edit",
        "full": "/portfolio/editorial-misc/full/IMG_0129-Edit.webp",
        "thumb": "/portfolio/editorial-misc/thumb/IMG_0129-Edit.webp",
        "alt": "Editorial - Selected Frames - photo 1 of 12 - editorial photographer Cape Town | Pie in the Sky Productions",
        "title": "Editorial - Selected Frames - editorial photographer Cape Town"
      },
      {
        "id": "IMG_0401",
        "full": "/portfolio/editorial-misc/full/IMG_0401.webp",
        "thumb": "/portfolio/editorial-misc/thumb/IMG_0401.webp",
        "alt": "Editorial - Selected Frames - photo 2 of 12 - editorial photographer Cape Town | Pie in the Sky Productions",
        "title": "Editorial - Selected Frames - editorial photographer Cape Town"
      },
      {
        "id": "IMG_0959",
        "full": "/portfolio/editorial-misc/full/IMG_0959.webp",
        "thumb": "/portfolio/editorial-misc/thumb/IMG_0959.webp",
        "alt": "Editorial - Selected Frames - photo 3 of 12 - editorial photographer Cape Town | Pie in the Sky Productions",
        "title": "Editorial - Selected Frames - editorial photographer Cape Town"
      },
      {
        "id": "IMG_1034",
        "full": "/portfolio/editorial-misc/full/IMG_1034.webp",
        "thumb": "/portfolio/editorial-misc/thumb/IMG_1034.webp",
        "alt": "Editorial - Selected Frames - photo 4 of 12 - editorial photographer Cape Town | Pie in the Sky Productions",
        "title": "Editorial - Selected Frames - editorial photographer Cape Town"
      },
      {
        "id": "IMG_5668",
        "full": "/portfolio/editorial-misc/full/IMG_5668.webp",
        "thumb": "/portfolio/editorial-misc/thumb/IMG_5668.webp",
        "alt": "Editorial - Selected Frames - photo 5 of 12 - editorial photographer Cape Town | Pie in the Sky Productions",
        "title": "Editorial - Selected Frames - editorial photographer Cape Town"
      },
      {
        "id": "IMG_5743-Edit",
        "full": "/portfolio/editorial-misc/full/IMG_5743-Edit.webp",
        "thumb": "/portfolio/editorial-misc/thumb/IMG_5743-Edit.webp",
        "alt": "Editorial - Selected Frames - photo 6 of 12 - editorial photographer Cape Town | Pie in the Sky Productions",
        "title": "Editorial - Selected Frames - editorial photographer Cape Town"
      },
      {
        "id": "IMG_6684",
        "full": "/portfolio/editorial-misc/full/IMG_6684.webp",
        "thumb": "/portfolio/editorial-misc/thumb/IMG_6684.webp",
        "alt": "Editorial - Selected Frames - photo 7 of 12 - editorial photographer Cape Town | Pie in the Sky Productions",
        "title": "Editorial - Selected Frames - editorial photographer Cape Town"
      },
      {
        "id": "IMG_6722",
        "full": "/portfolio/editorial-misc/full/IMG_6722.webp",
        "thumb": "/portfolio/editorial-misc/thumb/IMG_6722.webp",
        "alt": "Editorial - Selected Frames - photo 8 of 12 - editorial photographer Cape Town | Pie in the Sky Productions",
        "title": "Editorial - Selected Frames - editorial photographer Cape Town"
      },
      {
        "id": "IMG_6944",
        "full": "/portfolio/editorial-misc/full/IMG_6944.webp",
        "thumb": "/portfolio/editorial-misc/thumb/IMG_6944.webp",
        "alt": "Editorial - Selected Frames - photo 9 of 12 - editorial photographer Cape Town | Pie in the Sky Productions",
        "title": "Editorial - Selected Frames - editorial photographer Cape Town"
      },
      {
        "id": "IMG_8712",
        "full": "/portfolio/editorial-misc/full/IMG_8712.webp",
        "thumb": "/portfolio/editorial-misc/thumb/IMG_8712.webp",
        "alt": "Editorial - Selected Frames - photo 10 of 12 - editorial photographer Cape Town | Pie in the Sky Productions",
        "title": "Editorial - Selected Frames - editorial photographer Cape Town"
      },
      {
        "id": "IMG_9041",
        "full": "/portfolio/editorial-misc/full/IMG_9041.webp",
        "thumb": "/portfolio/editorial-misc/thumb/IMG_9041.webp",
        "alt": "Editorial - Selected Frames - photo 11 of 12 - editorial photographer Cape Town | Pie in the Sky Productions",
        "title": "Editorial - Selected Frames - editorial photographer Cape Town"
      },
      {
        "id": "New_8693",
        "full": "/portfolio/editorial-misc/full/New_8693.webp",
        "thumb": "/portfolio/editorial-misc/thumb/New_8693.webp",
        "alt": "Editorial - Selected Frames - photo 12 of 12 - editorial photographer Cape Town | Pie in the Sky Productions",
        "title": "Editorial - Selected Frames - editorial photographer Cape Town"
      }
    ],
    "count": 12,
    "seoKeyword": "editorial photographer Cape Town"
  },
  {
    "slug": "courtney-sanders",
    "label": "Courtney Sanders - Editorial",
    "category": "Editorial & Portraits",
    "protected": false,
    "photos": [
      {
        "id": "Courtney_Sanders",
        "full": "/portfolio/courtney-sanders/full/Courtney_Sanders.webp",
        "thumb": "/portfolio/courtney-sanders/thumb/Courtney_Sanders.webp",
        "alt": "Courtney Sanders - Editorial - photo 1 of 5 - editorial portrait photographer Cape Town | Pie in the Sky Productions",
        "title": "Courtney Sanders - Editorial - editorial portrait photographer Cape Town"
      },
      {
        "id": "Courtney_Sanders_2",
        "full": "/portfolio/courtney-sanders/full/Courtney_Sanders_2.webp",
        "thumb": "/portfolio/courtney-sanders/thumb/Courtney_Sanders_2.webp",
        "alt": "Courtney Sanders - Editorial - photo 2 of 5 - editorial portrait photographer Cape Town | Pie in the Sky Productions",
        "title": "Courtney Sanders - Editorial - editorial portrait photographer Cape Town"
      },
      {
        "id": "Courtney_Sanders_3",
        "full": "/portfolio/courtney-sanders/full/Courtney_Sanders_3.webp",
        "thumb": "/portfolio/courtney-sanders/thumb/Courtney_Sanders_3.webp",
        "alt": "Courtney Sanders - Editorial - photo 3 of 5 - editorial portrait photographer Cape Town | Pie in the Sky Productions",
        "title": "Courtney Sanders - Editorial - editorial portrait photographer Cape Town"
      },
      {
        "id": "Courtney_Sanders_4",
        "full": "/portfolio/courtney-sanders/full/Courtney_Sanders_4.webp",
        "thumb": "/portfolio/courtney-sanders/thumb/Courtney_Sanders_4.webp",
        "alt": "Courtney Sanders - Editorial - photo 4 of 5 - editorial portrait photographer Cape Town | Pie in the Sky Productions",
        "title": "Courtney Sanders - Editorial - editorial portrait photographer Cape Town"
      },
      {
        "id": "Courtney_Sanders_5",
        "full": "/portfolio/courtney-sanders/full/Courtney_Sanders_5.webp",
        "thumb": "/portfolio/courtney-sanders/thumb/Courtney_Sanders_5.webp",
        "alt": "Courtney Sanders - Editorial - photo 5 of 5 - editorial portrait photographer Cape Town | Pie in the Sky Productions",
        "title": "Courtney Sanders - Editorial - editorial portrait photographer Cape Town"
      }
    ],
    "count": 5,
    "seoKeyword": "editorial portrait photographer Cape Town"
  }
];
